import React, { useCallback, useState } from 'react';
import * as PropTypes from 'prop-types';
import { IconCheckmark, IconCopy } from '../Icons';

const CopyButton = ({ value, onClick }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = useCallback(
    text => {
      navigator.clipboard.writeText(text);
      setIsCopied(true);

      setTimeout(() => setIsCopied(false), 3000);
    },
    [setIsCopied],
  );

  if (isCopied) {
    return (
      <div className="-my-1 flex h-8 w-8 shrink-0 items-center justify-center text-green-500">
        <IconCheckmark size="5" />
      </div>
    );
  }

  return (
    <button
      className="-my-1 flex h-8 w-8 shrink-0 items-center justify-center text-blue-500 hover:text-blue-600"
      type="button"
      onClick={() => {
        copyToClipboard(value);
        onClick();
      }}
    >
      <IconCopy size="5" />
    </button>
  );
};

export default CopyButton;

CopyButton.defaultProps = {
  onClick: () => {},
};

CopyButton.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
